var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMutationOptionsFactory } from '../../util/query';
import { entryLinksApi, exportApi } from '../rest/api';
var mutationOptionsFactory = getMutationOptionsFactory();
export var entryLinkKeys = Object.freeze({
    all: ['entryLinks'],
    lists: function () {
        return __spreadArray(__spreadArray([], __read(entryLinkKeys.all), false), ['lists'], false);
    },
    list: function (ids) {
        return __spreadArray(__spreadArray([], __read(entryLinkKeys.lists()), false), [ids], false);
    },
    details: function () {
        return __spreadArray(__spreadArray([], __read(entryLinkKeys.all), false), ['details'], false);
    },
    detail: function (keyOrId) {
        return __spreadArray(__spreadArray([], __read(entryLinkKeys.details()), false), [keyOrId], false);
    },
});
function getEntryLinks() {
    return entryLinksApi.list();
}
export function useEntryLinks(options) {
    var listKey = entryLinkKeys.list();
    return useQuery(listKey, getEntryLinks, __assign({}, options));
}
function getEntryLinksByIds(context) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, ids, links;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = __read(context.queryKey, 3), ids = _a[2];
                    if (!ids) {
                        throw new Error('Invalid argument');
                    }
                    return [4 /*yield*/, entryLinksApi.list()];
                case 1:
                    links = _b.sent();
                    return [2 /*return*/, links.filter(function (l) { return ids.includes(l.id); })];
            }
        });
    });
}
export function useEntryLinksByIds(ids, options) {
    var listByIdsKey = entryLinkKeys.list(ids);
    var queryClient = useQueryClient();
    return useQuery(listByIdsKey, getEntryLinksByIds, __assign(__assign({}, options), { enabled: !!ids, initialData: function () {
            var listKey = entryLinkKeys.list();
            var links = queryClient.getQueryData(listKey);
            return links === null || links === void 0 ? void 0 : links.filter(function (l) { return ids === null || ids === void 0 ? void 0 : ids.includes(l.id); });
        } }));
}
function getEntryLinkByKey(context) {
    return __awaiter(this, void 0, Promise, function () {
        var _a, key;
        return __generator(this, function (_b) {
            _a = __read(context.queryKey, 3), key = _a[2];
            if (key === undefined || typeof key === 'number') {
                return [2 /*return*/, Promise.reject(new Error('User ID was not specified'))];
            }
            return [2 /*return*/, entryLinksApi.getByKey(key)];
        });
    });
}
export function useEntryLinkByKey(key, options) {
    var _a;
    var queryClient = useQueryClient();
    var queryKey = entryLinkKeys.detail(key);
    var entryLinkQuery = useQuery(queryKey, getEntryLinkByKey, __assign(__assign({}, options), { enabled: !!key && ((_a = options === null || options === void 0 ? void 0 : options.enabled) !== null && _a !== void 0 ? _a : true), initialData: function () {
            var allEntryLinks = queryClient.getQueryData(entryLinkKeys.list());
            var targetEntryLink = allEntryLinks === null || allEntryLinks === void 0 ? void 0 : allEntryLinks.find(function (el) { return el.key === key; });
            return targetEntryLink;
        } }));
    return entryLinkQuery;
}
function getEntryLink(context) {
    return __awaiter(this, void 0, Promise, function () {
        var _a, id;
        return __generator(this, function (_b) {
            _a = __read(context.queryKey, 3), id = _a[2];
            if (id === undefined || typeof id === 'string') {
                return [2 /*return*/, Promise.reject(new Error('User ID was not specified'))];
            }
            return [2 /*return*/, entryLinksApi.get(id)];
        });
    });
}
export function useEntryLink(id, options) {
    var _a;
    var queryClient = useQueryClient();
    var key = entryLinkKeys.detail(id);
    var entryLinkQuery = useQuery(key, getEntryLink, __assign(__assign({}, options), { enabled: !!id && ((_a = options === null || options === void 0 ? void 0 : options.enabled) !== null && _a !== void 0 ? _a : true), initialData: function () {
            var allEntryLinks = queryClient.getQueryData(entryLinkKeys.list());
            var targetEntryLink = allEntryLinks === null || allEntryLinks === void 0 ? void 0 : allEntryLinks.find(function (el) { return el.id === id; });
            return targetEntryLink;
        } }));
    return entryLinkQuery;
}
function createEntryLink(newEntryLink) {
    return entryLinksApi.create(newEntryLink);
}
export function useCreateEntryLink() {
    var key = entryLinkKeys.list();
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('create', key, queryClient);
    return useMutation(createEntryLink, options);
}
function updateEntryLink(updatedEntryLink) {
    var id = updatedEntryLink.id, rest = __rest(updatedEntryLink, ["id"]);
    return entryLinksApi.update(id, rest);
}
export function useUpdateEntryLink() {
    var key = entryLinkKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('update', key, queryClient);
    return useMutation(updateEntryLink, options);
}
function updateBatchEntryLinks(commands) {
    return entryLinksApi.updateBatch(commands);
}
export function useUpdateBatchEntryLinks() {
    var queryClient = useQueryClient();
    return useMutation(updateBatchEntryLinks, {
        onMutate: function (variables) {
            var listKey = entryLinkKeys.list();
            var previousLinks = queryClient.getQueryData(listKey);
            queryClient.setQueryData(listKey, function (links) {
                var e_1, _a;
                var _b;
                if (!links) {
                    return;
                }
                var updated = [];
                try {
                    for (var links_1 = __values(links), links_1_1 = links_1.next(); !links_1_1.done; links_1_1 = links_1.next()) {
                        var link = links_1_1.value;
                        if (variables.ids.includes(link.id)) {
                            updated.push(__assign(__assign({}, link), { duration: (_b = variables.updates.duration) !== null && _b !== void 0 ? _b : link.duration, versionIds: variables.updates.versionIds
                                    ? __spreadArray([], __read(variables.updates.versionIds), false) : link.versionIds, intervalEnd: variables.updates.intervalEnd
                                    ? new Date(variables.updates.intervalEnd)
                                    : link.intervalEnd, intervalStart: variables.updates.intervalStart
                                    ? new Date(variables.updates.intervalStart)
                                    : link.intervalStart }));
                            continue;
                        }
                        updated.push(link);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (links_1_1 && !links_1_1.done && (_a = links_1.return)) _a.call(links_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return updated;
            });
            return { previousLinks: previousLinks };
        },
        onError: function (error, variables, context) {
            var listKey = entryLinkKeys.list();
            //@ts-ignore
            queryClient.setQueryData(listKey, context === null || context === void 0 ? void 0 : context.previousLinks);
        },
        onSettled: function () {
            return queryClient.invalidateQueries(entryLinkKeys.all);
        },
    });
}
function deleteEntryLink(entryLinkId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entryLinksApi.remove(entryLinkId)];
        });
    });
}
export function useDeleteEntryLink() {
    var key = entryLinkKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('delete', key, queryClient);
    return useMutation(deleteEntryLink, options);
}
function deleteEntryLinks(entryLinkIds) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entryLinksApi.deleteBatch(entryLinkIds)];
        });
    });
}
export function useDeleteEntryLinks() {
    var listKey = entryLinkKeys.list();
    var queryClient = useQueryClient();
    return useMutation(deleteEntryLinks, {
        onMutate: function (ids) {
            var entryLinks = queryClient.getQueryData(listKey);
            queryClient.setQueryData(listKey, function (entryLinks) {
                return entryLinks === null || entryLinks === void 0 ? void 0 : entryLinks.filter(function (el) { return !ids.includes(el.id); });
            });
            return { previousEntryLinks: entryLinks };
        },
        onError: function (error, variables, context) {
            var _a;
            var previousEntryLinks = (_a = context) === null || _a === void 0 ? void 0 : _a.previousEntryLinks;
            queryClient.setQueryData(listKey, previousEntryLinks);
        },
        onSettled: function () {
            queryClient.invalidateQueries(listKey);
            queryClient.invalidateQueries(entryLinkKeys.details());
        },
    });
}
function refreshEntryLinks(entryLinkIds) {
    return __awaiter(this, void 0, void 0, function () {
        var entryLinkIds_1, entryLinkIds_1_1, id, e_2_1;
        var e_2, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 7]);
                    entryLinkIds_1 = __values(entryLinkIds), entryLinkIds_1_1 = entryLinkIds_1.next();
                    _b.label = 1;
                case 1:
                    if (!!entryLinkIds_1_1.done) return [3 /*break*/, 4];
                    id = entryLinkIds_1_1.value;
                    return [4 /*yield*/, entryLinksApi.refresh(id)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    entryLinkIds_1_1 = entryLinkIds_1.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (entryLinkIds_1_1 && !entryLinkIds_1_1.done && (_a = entryLinkIds_1.return)) _a.call(entryLinkIds_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function useRefreshEntryLinks() {
    var key = entryLinkKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('invalidate', key, queryClient);
    return useMutation(refreshEntryLinks, options);
}
function disableEntryLinks(entryLinkIds) {
    return __awaiter(this, void 0, void 0, function () {
        var entryLinkIds_2, entryLinkIds_2_1, id, e_3_1;
        var e_3, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 7]);
                    entryLinkIds_2 = __values(entryLinkIds), entryLinkIds_2_1 = entryLinkIds_2.next();
                    _b.label = 1;
                case 1:
                    if (!!entryLinkIds_2_1.done) return [3 /*break*/, 4];
                    id = entryLinkIds_2_1.value;
                    return [4 /*yield*/, entryLinksApi.disable(id)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    entryLinkIds_2_1 = entryLinkIds_2.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_3_1 = _b.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (entryLinkIds_2_1 && !entryLinkIds_2_1.done && (_a = entryLinkIds_2.return)) _a.call(entryLinkIds_2);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function useDisableEntryLink() {
    var key = entryLinkKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('invalidate', key, queryClient);
    return useMutation(disableEntryLinks, options);
}
function regenerateEntryLinks(entryLinkIds) {
    return __awaiter(this, void 0, void 0, function () {
        var entryLinkIds_3, entryLinkIds_3_1, id, e_4_1;
        var e_4, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 7]);
                    entryLinkIds_3 = __values(entryLinkIds), entryLinkIds_3_1 = entryLinkIds_3.next();
                    _b.label = 1;
                case 1:
                    if (!!entryLinkIds_3_1.done) return [3 /*break*/, 4];
                    id = entryLinkIds_3_1.value;
                    return [4 /*yield*/, entryLinksApi.regenerate(id)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    entryLinkIds_3_1 = entryLinkIds_3.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_4_1 = _b.sent();
                    e_4 = { error: e_4_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (entryLinkIds_3_1 && !entryLinkIds_3_1.done && (_a = entryLinkIds_3.return)) _a.call(entryLinkIds_3);
                    }
                    finally { if (e_4) throw e_4.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function useRegenerateEntryLink() {
    var key = entryLinkKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('invalidate', key, queryClient);
    return useMutation(regenerateEntryLinks, options);
}
export function exportEntryLinks(ids) {
    return exportApi.exportEntryLinks({ entryLinkIds: ids });
}
export function useExportEntryLinks() {
    return useMutation(exportEntryLinks);
}
